import { Avatar, Checkbox, HStack, Text, VStack } from '@chakra-ui/react'
import { getAvatarColorById } from '../constants/avatarColors'

export interface AssignPrescriberListItemProps {
  id: string
  title?: string
  name: string
  subtitle: string
  isChecked: boolean
  onToggle: (id: string, checked: boolean) => void
}

const buildInitials = (name: string): string => {
  const parts = name.split(' ').filter(Boolean)
  const first = parts[0] ?? ''
  const last = parts.length > 1 ? parts[parts.length - 1] : ''

  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase()
}

export const AssignPrescriberListItem = ({
  id,
  title,
  name,
  subtitle,
  isChecked,
  onToggle,
}: AssignPrescriberListItemProps) => {
  const avatarBg = getAvatarColorById(id)
  const displayName = title ? `${title} ${name}`.trim() : name

  return (
    <HStack
      spacing={3}
      py={2}
      px={3}
      borderBottom="1px"
      borderColor="gray.100"
      align="center"
      bg={isChecked ? 'blue.50' : 'transparent'}
      _last={{ borderBottom: 'none' }}
    >
      <Checkbox
        size="md"
        colorScheme="blue"
        isChecked={isChecked}
        onChange={(event) => onToggle(id, event.target.checked)}
        aria-label={`Select ${displayName}`}
      />

      <Avatar
        size="sm"
        name={name}
        bg={avatarBg}
        color="white"
        fontWeight="bold"
        fontSize="xs"
        getInitials={buildInitials}
      />

      <VStack align="flex-start" spacing={0} flex={1}>
        <Text fontSize="sm" fontWeight="bold" lineHeight="1.2" color="gray.900">
          {displayName}
        </Text>
        <Text fontSize="xs" color="gray.500" lineHeight="1.2">
          {subtitle}
        </Text>
      </VStack>
    </HStack>
  )
}
